import React from "react";
import StaticPageLayout, { useWeavevoI18n } from "./StaticPageLayout";

const I18N = {
  en: {
    title: "Cookie Policy",
    intro:
      "This page describes how cookies and similar technologies may be used on Weavevo. Adapt it according to the cookies you actually use.",
    h1: "What is a cookie?",
    p1:
      "A cookie is a small file stored on your device that helps recognize your browser or remember certain preferences.",
    h2: "Types of cookies",
    li1: "Essential: required for core functionality (authentication, security).",
    li2: "Preferences: language, display settings.",
    li3: "Analytics: audience measurement/statistics (only if enabled).",
    h3: "Consent management",
    p3:
      "You can accept/refuse non-essential cookies via a banner or preference center (to be implemented).",
    h4: "How to disable?",
    p4:
      "You can also change your browser settings to delete or block cookies.",
  },
  fr: {
    title: "Politique de cookies",
    intro:
      "Cette page décrit l’usage des cookies et technologies similaires sur Weavevo. À adapter selon les cookies réellement utilisés.",
    h1: "Qu’est-ce qu’un cookie ?",
    p1:
      "Un cookie est un petit fichier stocké sur votre terminal qui permet de reconnaître votre navigateur ou de mémoriser certaines préférences.",
    h2: "Types de cookies",
    li1: "Essentiels : nécessaires au fonctionnement (authentification, sécurité).",
    li2: "Préférences : langue, affichage.",
    li3: "Mesure d’audience : statistiques (uniquement si activé).",
    h3: "Gestion du consentement",
    p3:
      "Vous pouvez accepter/refuser les cookies non essentiels via une bannière / un centre de préférences (à implémenter).",
    h4: "Comment désactiver ?",
    p4:
      "Vous pouvez également modifier les réglages de votre navigateur pour supprimer ou bloquer les cookies.",
  },
};

export default function PolitiqueCookies() {
  const { t } = useWeavevoI18n(I18N);

  return (
    <StaticPageLayout title={t("title")}>
      <p>{t("intro")}</p>

      <h2>{t("h1")}</h2>
      <p>{t("p1")}</p>

      <h2>{t("h2")}</h2>
      <ul>
        <li><strong>{t("li1")}</strong></li>
        <li><strong>{t("li2")}</strong></li>
        <li><strong>{t("li3")}</strong></li>
      </ul>

      <h2>{t("h3")}</h2>
      <p>{t("p3")}</p>

      <h2>{t("h4")}</h2>
      <p>{t("p4")}</p>
    </StaticPageLayout>
  );
}
